import React, { useEffect, useState } from "react";
import CreatePage from "../../controls/CreatePage";
import { getKOT } from "../../../api/KOTApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import NoDataFound from "../../controls/NoDataFound";
import Loading from "../../controls/Loading";
import { useNavigate } from "react-router-dom";

const KOTCustomerDisplay = () => {
  const store = useSelector((state) => state.store.store);
  const [loading, setLoading] = useState(false);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [readyOrders, setReadyOrders] = useState([]);
  const navigate=useNavigate();

const fetchOrders = async (hideLoading = false) => {
  try {
    if (!hideLoading) {
      setLoading(true);
    }

    const [pendingResponse, readyResponse] = await Promise.all([
      getKOT(store?.key, "Pending"),
      getKOT(store?.key, "Ready"),
    ]);

    if (pendingResponse?.code === "0") {
      setPendingOrders(pendingResponse?.orders || []);
    }

    if (readyResponse?.code === "0") {
      setReadyOrders(readyResponse?.orders || []);
    }
  } catch (error) {
    toast.error("Failed to load orders");
  } finally {
    if (!hideLoading) {
      setLoading(false);
    }
  }
};

useEffect(() => {
  if (!store?.key) return;

  // First time → show loading
  fetchOrders(false);

  // Interval → do NOT show loading
  const intervalId = setInterval(() => {
    fetchOrders(true);
  }, 10000);

  return () => clearInterval(intervalId);
}, [store]);

  return (
    <CreatePage handleCancel={()=>{navigate(-1)}} showFooter={false} title="Kitchen Order Display">
      <div className="w-full bg-gray-50 min-h-screen p-4">
        {loading ? (
          <Loading />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Pending Orders Section */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-orange-500 text-white px-4 py-3">
                <h2 className="text-lg font-semibold">Preparing ({pendingOrders.length})</h2>
              </div>
              <div className="p-4 max-h-[600px] overflow-y-auto">
                {pendingOrders.length === 0 ? (
                  <NoDataFound message="No orders preparing" />
                ) : (
                  <div className="space-y-3">
                    {pendingOrders.map((order) => (
                      <div
                        key={order.KOTNo}
                        className="bg-orange-50 border border-orange-200 rounded-lg p-4 text-center"
                      >
                        <span className="text-2xl font-bold text-orange-700">
                          {order.KOTNo}
                        </span>
                      
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Ready Orders Section */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-green-500 text-white px-4 py-3">
                <h2 className="text-lg font-semibold">Ready ({readyOrders.length})</h2>
              </div>
              <div className="p-4 max-h-[600px] overflow-y-auto">
                {readyOrders.length === 0 ? (
                  <NoDataFound message="No ready orders" />
                ) : (
                  <div className="space-y-3">
                    {readyOrders.map((order) => (
                      <div
                        key={order.KOTNo}
                        className="bg-green-50 border border-green-200 rounded-lg p-4"
                      >
                        <div className=" text-center">
                          <div>
                            <span className="text-2xl font-bold text-green-700">
                              {order.KOTNo}
                            </span>
                           
                          </div>
                        
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </CreatePage>
  );
};

export default KOTCustomerDisplay;